var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceptButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17039",
    "data-name": "Groupe 17039",
    transform: "translate(-1431 -174)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5502",
    "data-name": "Rectangle 5502",
    width: 36,
    height: 36,
    rx: 10,
    transform: "translate(1431 174)",
    fill: "#41b15d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M12.375,3.375a9,9,0,1,0,9,9A9,9,0,0,0,12.375,3.375Zm4.608,6.512L11.2,15.7h0a.781.781,0,0,1-.5.238.758.758,0,0,1-.506-.247L7.762,13.266a.172.172,0,0,1,0-.247l.77-.77a.167.167,0,0,1,.242,0L10.7,14.171l5.279-5.318A.171.171,0,0,1,16.1,8.8h0a.157.157,0,0,1,.121.052l.757.783A.171.171,0,0,1,16.983,9.887Z",
    transform: "translate(1437.225 180.225)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptButton);
export default __webpack_public_path__ + "static/media/acceptButton.3f4cc1dbc77c0b4cfe91deeb352e7555.svg";
export { ForwardRef as ReactComponent };